import { useState, useEffect } from "react"
import styles from "./grupos.module.css"
import api from "../../api"
import Sidebar from "../../Components/Sidebar"
import { useLocation, useNavigate, useParams } from "react-router-dom"

export default function GrupoForm() {

    const navigate = useNavigate();

    const location = useLocation();
    const grupo = location.state;
    const { id } = useParams()


    const [nome, setNome] = useState("")
    const [descricao, setDescricao] = useState("")
    const [busca, setBusca] = useState("")
    const [colaboradores, setColaboradores] = useState([])
    const [membros, setMembros] = useState([])
    const [editando, setEditando] = useState(!!id);
    const [loading, setLoading] = useState(false);


    const [setores, setSetores] = useState([])
    const [filtroSetor, setFiltroSetor] = useState("")
    const [filtroTipo, setFiltroTipo] = useState("")
    const [filtroGenero, setFiltroGenero] = useState("")
    const [filtroNivel, setFiltroNivel] = useState([
        "Coordenador(a)",
        "Gerente",
        "Supervisor(a) de RH",
        "Diretor(a)",
        "Sucessor",
        "Outros"
    ])

    function toggleNivel(nivel) {

        if (filtroNivel.includes(nivel)) {

            setFiltroNivel(
                filtroNivel.filter(n => n !== nivel)
            )

        } else {

            setFiltroNivel([
                ...filtroNivel,
                nivel
            ])

        }

    }

    async function CarregaMembros() {

        try {

            setLoading(true)

            const response = await api.get(`/portal/membros/?codgru=${grupo.codgru}`)

            const data = response.data

            setMembros(data);

        } catch (error) {

            alert("Erro ao conectar com servidor : " + error)

        } finally {

            setLoading(false)

        }

    }




    async function GetPessoas() {
        try {
            setLoading(true);

            const response = await api.get(`/portal/lista`);


            const data = response.data;

            setColaboradores(data);


            const setor = [
                ...new Set(data.map(c => c.setor))
            ]

            setSetores(setor);


        } catch (error) {
            alert("Erro ao conectar com servidor : " + error);
        } finally {
            setLoading(false);
        }
    }





    useEffect(() => {



        GetPessoas();


        if (editando) {
            setNome(grupo.nomgru);
            setDescricao(grupo.desgru);
            CarregaMembros();
        }

    }, [])


    const resultados = colaboradores.filter(c => {

        // se estiver editando → NÃO filtra membros fora do filtro
        if (editando) {

            const isMembro = membros.find(m => m.codfun === c.codfun)

            if (isMembro) return true

        }

        const matchBusca =
            c.nomfun.toLowerCase().includes(busca.toLowerCase())

        const matchTipo =
            !filtroTipo || c.tipfun === filtroTipo

        const matchGenero =
            !filtroGenero || c.sexfun === filtroGenero

        const matchSetor =
            !filtroSetor || c.setor === filtroSetor

        const matchNivel =
            filtroNivel.includes(c.desfun)

        return matchBusca && matchTipo && matchGenero && matchNivel && matchSetor

    })








    function togglePessoa(pessoa) {
        
        
        const existe = membros.find(m => m.codfun === pessoa.codfun)

        if (existe) {

            setMembros(membros.filter(m => m.codfun !== pessoa.codfun))

        } else {

            setMembros([...membros, pessoa])

        }

    }

    function removerPessoa(id) {

        setMembros(membros.filter(m => m.codfun !== id))

    }


    async function salvarGrupo() {

        const payload = {
            nome,
            descricao,
            membros: membros
        }

        if (editando) {
            const response = await api.put(`/portal/grupos/?codgru=${grupo.codgru}`,payload);
            const data = response.data;


        } else {
            const response = await api.post(`/portal/grupos/`,payload);
            const data = response.data;
        }

        limparFormulario()
        navigate('/grupos');
    }


    function limparFormulario() {
        setEditando(null)
        setNome("")
        setDescricao("")
        setMembros([])

    }

    function selecionarTodos() {

        const novos = resultados.filter(r =>
            !membros.find(m => m.codfun === r.codfun)
        )

        setMembros([
            ...membros,
            ...novos
        ])

    }

    function limparSelecao() {

        setMembros([])

    }


    return (

        <div className={styles.layout}>

            <Sidebar />

            <div className={styles.main}>

                <div className={styles.content}>


                    <div className={styles.pageHeader}>
                        <div>
                            <span className={styles.pageLabel}>Comunicação</span>
                            <h1 className={styles.pageTitle}>{editando ? "Editar Grupo" : "Novo Grupo"}</h1>
                        </div>
                    </div>

                    {/* FORMULÁRIO */}

                    <div className={styles.form}>


                        <input
                            placeholder="Nome do grupo"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                        />


                        <textarea
                            placeholder="Descrição"
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                        />


                        <input
                            placeholder="Buscar pessoa..."
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                        />

                        <div className={styles.filtros}>

                            <select
                                value={filtroTipo}
                                onChange={(e) => setFiltroTipo(e.target.value)}
                            >
                                <option value="">Tipo</option>
                                <option value="F">Funcionário</option>
                                <option value="T">Terceiro</option>
                            </select>


                            <select
                                value={filtroGenero}
                                onChange={(e) => setFiltroGenero(e.target.value)}
                            >
                                <option value="">Gênero</option>
                                <option value="M">Masculino</option>
                                <option value="F">Feminino</option>
                            </select>

                            <select
                                value={filtroSetor}
                                onChange={(e) => setFiltroSetor(e.target.value)}
                            >

                                <option value="">
                                    Todos os setores
                                </option>

                                {setores.map(setor => (

                                    <option
                                        key={setor}
                                        value={setor}
                                    >
                                        {setor}
                                    </option>

                                ))}

                            </select>


                            <div className={styles.niveis}>

                                <label>
                                    <input
                                        type="checkbox"
                                        checked={filtroNivel.includes("Coordenador(a)")}
                                        onChange={() => toggleNivel("Coordenador(a)")}
                                    />
                                    Coordenador
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        checked={filtroNivel.includes("Gerente")}
                                        onChange={() => toggleNivel("Gerente")}
                                    />
                                    Gerente
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        checked={filtroNivel.includes("Supervisor(a) de RH")}
                                        onChange={() => toggleNivel("Supervisor(a) de RH")}
                                    />
                                    Supervisor
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        checked={filtroNivel.includes("Diretor(a)")}
                                        onChange={() => toggleNivel("Diretor(a)")}
                                    />
                                    Diretor
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        checked={filtroNivel.includes("Sucessor")}
                                        onChange={() => toggleNivel("Sucessor")}
                                    />
                                    Sucessor
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        checked={filtroNivel.includes("Outros")}
                                        onChange={() => toggleNivel("Outros")}
                                    />
                                    Outros
                                </label>

                            </div>

                        </div>

                        <div className={styles.acoesLista}>

                            <button
                                onClick={selecionarTodos}
                            >
                                Selecionar todos
                            </button>

                            <button
                                onClick={limparSelecao}
                            >
                                Limpar seleção
                            </button>

                        </div>

                        <div className={styles.grid}>



                            {/* RESULTADOS */}

                            <div className={styles.lista}>



                                {resultados.map(p => {

                                    const selecionado = membros.find(m => m.codfun === p.codfun)

                                    return (

                                        <div
                                            key={p.codfun}
                                            className={styles.item}
                                            onClick={() => togglePessoa(p)}
                                        >

                                            {p.nomfun}

                                            <input
                                                type="checkbox"
                                                checked={!!selecionado}
                                                readOnly
                                            />

                                        </div>

                                    )

                                })}

                            </div>



                            {/* MEMBROS */}

                            <div className={styles.lista}>

                                <strong>
                                    Membros ({membros.length})
                                </strong>

                                {membros.map(p => (

                                    <div key={p.codfun} className={styles.item}>

                                        {p.nomfun}

                                        <button
                                            onClick={() => removerPessoa(p.codfun)}
                                        >
                                            ✕

                                        </button>

                                    </div>

                                ))}

                            </div>


                        </div>



                        <button
                            className={styles.salvar}
                            onClick={salvarGrupo}
                        >

                            Salvar Grupo

                        </button>

                    </div>


                </div>

            </div>

        </div>

    )
}